// Custom element to contain logic for swapping product images from
// default 'product' image to a special 'lifestyle' image.
// User enables the mode in Shopify UI 'Product Grid Component'
// When enabled, and when product itself has an image with '[LIFESTYLE]' in
// the alt text, data attributes will be set on the product, and contain
// alternate srcSet and src values, to be swapped out when user swaps between
// 'product' and 'lifestyle' buttons on the product grid UI.

class LifestyleImageToggle extends HTMLElement {
  constructor() {
    super();
    this.buttons = [];
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll("button");
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.handleButtonClick.bind(this));
    });
    this.initializeImgChoice();
  }

  handleButtonClick(e) {
    this.setActive(e.target);
  }

  setActive(el) {
    // set buttons active=false
    this.buttons.forEach((button) => {
      button.setAttribute("data-active", "false");
    });
    // set clicked button to active=true
    el.setAttribute("data-active", "true");
    // set session value:
    sessionStorage.setItem("custom_image-pref", el.value);
    // swap the images
    this.swapImages(el.value);
  }

  initializeImgChoice() {
    // check session storage for previous image preference and set, or
    // use 'product' as default
    const activeValue = sessionStorage.getItem("custom_image-pref");
    const buttonArr = Array.from(this.buttons);
    const buttonToActivate = activeValue
      ? buttonArr.find((button) => button.value === activeValue)
      : buttonArr.find((button) => button.value === "product");

    // If a button to activate is found, set it as active
    if (buttonToActivate) {
      this.setActive(buttonToActivate);
    }
  }

  swapImages(imageType) {
    // swap images to imageType 'product' or 'lifestyle'
    const prodContainer = document.getElementById("product-grid");

    if (prodContainer) {
      const prods = prodContainer.querySelectorAll(
        '[data-has-lifestyle="true"]'
      );

      prods.forEach((prod) => {
        const srcSet = prod.getAttribute(`data-${imageType}-srcset`);
        const src = prod.getAttribute(`data-${imageType}-src`);

        if (srcSet) prod.setAttribute("srcSet", srcSet);
        if (src) prod.setAttribute("src", src);
      });
    }
  }
}
customElements.define("lifestyle-image-toggle", LifestyleImageToggle);

